export const calculateAppliedDepth = (durationMinutes: number, applicationRate: number): number => {
  const hours = durationMinutes / 60

  return hours * applicationRate
}
